module.exports = __webpack_public_path__ + "img/logo-gob.c3f5aa5d.svg";